<div [innerHTML]="message"></div>
<button class="k-button k-outline" (click)="ignoreNotification($event)">X</button>
